import { cn } from '@mdvip/shared/lib/utils';
import type * as React from 'react';

/**
 * Skeleton: a low-emphasis placeholder block for loading states. A muted, pulsing surface sized
 * with utility classes to stand in for text lines, avatars, chips, and thumbnails while data
 * streams in. Compose several to mirror the real content's layout so nothing jumps on arrival.
 *
 * Prefer this over hand-rolled `animate-pulse bg-muted` divs so every loading state shares one
 * surface tone and pulse timing.
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}

export { Skeleton };
